import { css } from '@emotion/css';
import { N200, R500 } from '@assets/colors';

export const stySpinner = (props) => css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: solid 1px ${props.error ? R500 : N200};
  border-radius: 4px;

  input {
    flex-grow: 1;
    border: none;
    text-align: center;
    padding: 4px 0px;
    outline: none;
  }

  button {
    padding: 6px !important;
  }
`;
